import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import posthog from 'posthog-js'

posthog.init(
  'phc_hJk1h8QkZXapoCO7bAq7gN97MXN4mtI7qwt2a50TGy5',
  {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
    defaults: '2025-11-30',
    capture_pageview: false // Disabled - handled by PosthogService with correct page titles
  }
)

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
});
